import React from 'react';
import { useSelector } from 'react-redux';
import style from '../style.module.less';
import Global from '../../../../../store/global-selectors';

const ShipmentCountColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const { shipmentCount } = fulfillmentPlanSet ?? {};

  return <div className={style['right-aligned']}>{shipmentCount}</div>;
};

export default {
  id: 'shipment-count',
  messageDescriptorKey: 'shipmentCount',
  orderByParam: 'ShipmentCount',
  width: 120,
  render: ({ fulfillmentPlanSetId }) => <ShipmentCountColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
};
